// extracted by mini-css-extract-plugin
export default {"buttonGroup":"group-gift-goal-amount-form__buttonGroup__bxBa1","customLink":"group-gift-goal-amount-form__customLink__TJH3X"};